import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { http } from "../../shared/api/http.js";

export interface Client {
  id: string;
  email: string;
  name: string;
  createdAt: string;
  lastLoginAt: string | null;
}

const KEY = ["admin", "clients"] as const;

export const useClients = () =>
  useQuery({ queryKey: KEY, queryFn: () => http.get<{ items: Client[] }>("/admin/clients") });

export function useCreateClient() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: {
      name: string;
      email: string;
      mode: "password" | "invite";
      password?: string;
    }) => http.post<{ userId: string; inviteUrl: string | null }>("/admin/clients", v),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
